var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "url(#pattern0_7699_8588)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7699_8588",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7699_8588",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7699_8588",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADFElEQVR4nO2dTW8TMRCG9wRHEGckVE9OharMpELcgZ9HVaoCfwa4o0i9ABd+AfI0SaE9gorcJiiqaLXJ2h57932kuSW78fv4Y5PsR9MAAAAAAAAAAAAAANCSH2O3o0xvvLivKu5chS76Xe78sq1MB9M998Sso3wfje56pnde6I99KGRSoe2e3duL7e07BuG7T9YBaCHlmT5mleCF3ls3Wgsrz+4o25w/5GlHbxRAv6e79Di5gLDgWjdWiy23n1yAF/fNvqFUZHmmL8kFqLgz64ZqoeXZ/cogwL6hWnBBgECAeS9UjAD7IBRTkH0YalBYAwQCzHuhYgTYB6GYgtqF4JlOT8ZbrzzT52yhsTtWdi8803TQa4C/Cv9Z2O5s7O5lkcDu+PT5wwdhn35vxLElVCNgNfwlySWshL8ktoQmNanCTy7hP+GnkNCkJmX4ySTcEn5sCU1qun7Ak6dbL9vsZ7776L4XmnQWLjQJ22qzz/DZei+gTW+MNhJy7qsaAbmC4fzh1yMgdUBsE35dAlIFxXbh1ydAIgdmHH6dAiRScAWEX68A6RhgIeHXLUA2DLKg8OsXIOt9cQqvW+e1Mb7Y9V6ArjkS2pDtl9beCJB4EnKG3y8B0l1C7vD7J0A2l2ARfj8FyPoSrMKHgAUQgCkoHSVPPdfBImwY/hIchhqGvwRfxNYI3+OniNspZc6f4ce4AsKXCO+NXE1qiun5kmAbgxTA+EvSTgDjT3m7EYDTUjaj+PDFdk1oUlNF+GInoUlN1w+Ik3ONBeD09I7EmCdxgYaxgJskzHCJUj4B1yXMcJFe3hHwT4LQPCzMOU6aWtnnZLHPeextN6nJFZJWWhAgEGDeCxUjwD4IxRRkH4YaFNYAgQDzXqgYAfZBaH+nINy4VW8I37P7mVwAbl1MxrcuZjqwHuZabLnXyQWEx3aEW7XbN5aGefv6QHhsh3WDtbhyh00uwuM6wmM77BtNRZQX+pD9OTJXEtzRkKcjf9l2d5g9/FXCvBeeHBGOAIZxiOrOFm3dzzbnAwAAAAAAAAAAAICmD/wFen6YsLa8iA0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.f7f7c340e5f018439d24ea16f4a39ea0.svg";
export { ForwardRef as ReactComponent };